import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import collapse from '@alpinejs/collapse';
import AlpineI18n from 'alpinejs-i18n';

import {i18n} from "./utils/i18n";
import {wpMu} from "./utils/wp-mu";
import {trackPageview} from "./utils/plausible";

import {componentLikes} from "./components/component.likes";
import {componentFavorite} from "./components/component.favorite";
import {componentNavigation} from "./components/component.navigation";
import {componentVimeoVideo} from "./components/component.vimeo-video";
import {componentAccordions} from "./components/component.accordions";
import {courseVideoHasEnded} from "./courses/course-video-has-ended";
import {courseModuls} from "./courses/course-moduls";
import {courseLesson} from "./courses/course-lesson";
import {BlockAudio} from "./blocks/block.audio";
import {
    validateCreateForm,
    validateLoginForm,
    validateNotificationForm,
    validatePasswordForm,
    validateDeleteUserForm
} from "./components/component.validator";
import {userNotificationForm} from "./user-backend/user-notification-form";
import {track404} from "./utils/404";
import {userDeleteForm} from "./user-backend/user-delete-form";
import {userFavorites} from "./user-backend/user-favorites";
import {componentArticles} from "./components/component.articles";

trackPageview();

document.addEventListener("DOMContentLoaded", function () {
    window.Alpine = Alpine;

    window.onkeydown = function(e) {
        return !(e.keyCode == 32 && e.target == document.body);
    };

    wpMu();
    i18n();
    track404();

    componentAccordions();
    componentLikes();
    componentFavorite();
    componentNavigation();
    componentVimeoVideo();
    componentArticles();

    courseLesson();
    courseModuls();
    courseVideoHasEnded();

    BlockAudio();

    validateLoginForm()
    validateCreateForm();
    validatePasswordForm();
    validateNotificationForm();
    validateDeleteUserForm();

    userFavorites();
    userNotificationForm();
    userDeleteForm();

    Alpine.plugin(focus);
    Alpine.plugin(collapse);
    Alpine.plugin(AlpineI18n);

    // Find elements with the class 'gform_wrapper'
    let _gform_wrapper = document.querySelectorAll('.gform_wrapper');
    _gform_wrapper.forEach(function (el) {
        // Make the 'gform_wrapper' visible
        el.style.display = 'block';
    });

    Alpine.start()

    document.callLoginOverlay = function () {
        document.getElementById('user-menu').click()
    }
});